import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";

const Role = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
     
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        <Typography
          variant={isMobile ? "h4" : "h3"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Times New Roman", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          TECHANIC
        </Typography>
        <Typography
          variant={isMobile ? "h5" : "p"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Times New Roman", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          BUSINESS
        </Typography>
      </Box>

      
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Container maxWidth="sm">
          
          <Box sx={{ mb: 2, textAlign: "left" }}>
          <Typography
              sx={{
                color: "white",
                textShadow: "0 0 6px rgba(0,0,0,0.5)",
                fontSize: {
                  xs: "1.2rem",  
                  sm: "1.5rem",  
                  md: "1.75rem", 
                },
                lineHeight: 1.2,
              }}
            >
              Hi Dr Gadget Indonesia!
            </Typography>
            <Typography
              fontWeight="bold"
              sx={{
                color: "white",
                textShadow: "0 0 6px rgba(0,0,0,0.5)",
                fontSize: {
                  xs: "1.2rem",  
                  sm: "1.5rem",  
                  md: "1.75rem", 
                },
                lineHeight: 1.2,
              }}
            >
              Silahkan pilih tipe<br />akun anda
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            
            <Link to="/dashboard" style={{ textDecoration: "none" }}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  },
                }}
              >
                <PersonIcon sx={{ fontSize: 48, color: "primary.main" }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" color="text.primary">
                    Pemilik Usaha
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Saya adalah pemilik usaha
                  </Typography>
                </Box>
              </Paper>
            </Link>

            
            <Link to="/dashboard" style={{ textDecoration: "none" }}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                  },
                }}
              >
                <SettingsIcon sx={{ fontSize: 48, color: "secondary.main" }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" color="text.primary">
                    Teknisi/Pegawai
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Saya bekerja sebagai teknisi
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Role;
